import axios from "axios";
import { baseServerUrl } from "../../constants/default_request";

const api = axios.create({
  baseURL: baseServerUrl,
});

const errorHandler = (error) => {
  return Promise.reject(error);
};

api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error);
});

export default api;
